export const EMPTY_TOOL_PARAMETERS = {
  type: 'object',
  properties: {},
  additionalProperties: false,
};

export function stringToolParameters({ name, description, required = true }) {
  return {
    type: 'object',
    properties: {
      [name]: {
        type: 'string',
        description,
      },
    },
    required: required ? [name] : [],
    additionalProperties: false,
  };
}

export function objectToolParameters({ properties, required = [] }) {
  return {
    type: 'object',
    properties,
    required,
    additionalProperties: false,
  };
}
